export const getRole = state => state.role;
